import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, timeout } from 'rxjs/operators';
import { BBResponseContainer } from '../../carrier/response-container';
import { environment } from "../../../environments/environment";
import { SamplePlateHistoryDTO } from './../../models/samplePlateHistoryDTO';
import { SampleCommentDTO } from './../../models/sampleCommentDTO';
import { Sample } from '../../models-new/sample';
import { map } from 'rxjs/operators'
import { SearchAnnounce } from './../../models/searchAnnounce';
import { ProcessUpdateDTO } from './../../models/wb-process-update';
import { PlateAnnouncementDTO } from './../../dto/plateAnnouncementDTO';
import { SampleRedoDTO } from './../../models/sampleRedoDTO';

@Injectable({
  providedIn: 'root'
})
export class AnnouncedService {

  readonly timeoutForExcelSave = 30000;

  constructor(
    private http: HttpClient
  ) { }

  getAnnouncedList(searchdata, skip, limit):  Observable<BBResponseContainer>{
    let url = environment.BB_MA_DELIVERY_API +'apg/announced/search';
    let requestParam = new HttpParams().set('skip', skip).set('limit',limit).set('export', 'false');
    const options = url ? { params: requestParam } : {};
    return this.http.post<BBResponseContainer>(url, searchdata, options).pipe(timeout(environment.defaultTimeout), tap(event => {console.log(event) }, error => {
      error.url = url;
    }));
  }

  getExportData(searchdata, skip, limit, isExport){
    let url = environment.BB_MA_DELIVERY_API +'apg/announced/search';
    let requestParam = new HttpParams().set('skip', skip).set('limit',limit).set('export', isExport);
    const options = url ? { params: requestParam } : {};
    return this.http.post<BBResponseContainer>(url, searchdata, options).pipe(timeout(environment.defaultTimeout), tap(event => { console.log(event)}, error => {
      error.url = url;
    }));
  }

  uploadManualAnnouncedData(formData: FormData): Observable<BBResponseContainer> {
    let url = environment.BB_MA_DELIVERY_API + "ma/announced/plate/file";
    return this.http.post<BBResponseContainer>(url, formData).pipe(timeout(this.timeoutForExcelSave), tap(event => { console.log(event)}, error => {
      error.url = url;
    }));
  }

  getAllDeliveySamples(searchAnnounce: SearchAnnounce): Observable<BBResponseContainer> {
    let url = environment.BB_MA_DELIVERY_API + "ma/announced/delivery";
    return this.http.post<BBResponseContainer>(url, searchAnnounce).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  addSample(labId: string, sampleId: string, sample: any): Observable<BBResponseContainer>{
    let url = environment.BB_MA_DELIVERY_API + "addSample/"+labId+"/"+sampleId;
    return this.http.post<BBResponseContainer>(url,sample);
  }

  getSampleFromDelivery(labId : string, sampleId: string,projectID = ""): Observable<BBResponseContainer> {
    const encodedSampleId = encodeURIComponent(sampleId);
    let params = new HttpParams();
    if(projectID){
        params = params.set('projectID',projectID);
    }
    const url = `${environment.BB_MA_DELIVERY_API}sample/${labId}/${encodedSampleId}`;
    return this.http.get<BBResponseContainer>(url,{params});
  }

  validateAndSaveBarcodeFile(barcodeFileReqDto: FormData) {

    const url = `${environment.BB_MA_DELIVERY_API}validate/samples/file`;
    return this.http.post<BBResponseContainer>(url, barcodeFileReqDto).pipe(timeout(environment.defaultTimeout));
  }

  updateSamplePlateHistory(labId: string, sampleId: string, plateHistory: SamplePlateHistoryDTO): Observable<BBResponseContainer>{
    let url = environment.BB_MA_DELIVERY_API + "addPlateHistory/"+labId+"/"+sampleId;
    return this.http.put<BBResponseContainer>(url,plateHistory);
  }

  updateSampleComment(labId: string, sampleId: string, comment: SampleCommentDTO): Observable<BBResponseContainer>{
    let url = environment.BB_MA_DELIVERY_API + "addComment/"+labId+"/"+sampleId;
    return this.http.put<BBResponseContainer>(url,comment);
  }

  getPlateHistory(labId: string, plateId: string): Observable<BBResponseContainer>{
    let url = environment.BB_MA_DELIVERY_API + "plateHistory/"+labId+"/"+plateId;
    return this.http.get<BBResponseContainer>(url);
  }

  getSampleComments(labId: string, sampleId: string): Observable<BBResponseContainer>{
    let url = environment.BB_MA_DELIVERY_API + "sampleComments/"+labId+"/"+sampleId;
    return this.http.get<BBResponseContainer>(url);
  }

  receiveSample(labId: string, sampleId: string, puid: string){
    let url = environment.BB_MA_DELIVERY_API + "receiveSample/"+labId+"/"+sampleId+"/"+puid;
    return this.http.put<BBResponseContainer>(url, null);
  }

  addSampleToPlate(labId: string, sampleId: string, data: any){
    let url = environment.BB_MA_DELIVERY_API + "addSampleToPlate/"+labId+"/"+sampleId;
    return this.http.put<BBResponseContainer>(url, data);
  }

  addBoxToSampleSetAside(labId: string, sampleId: string, data:any){
    let url = environment.BB_MA_DELIVERY_API + `addBoxToSampleSetAside/${labId}/${sampleId}`
    return this.http.put<BBResponseContainer>(url,data)
  }

  updateSample(labId: string, sampleId: string, sample: Sample){
    let url = environment.BB_MA_DELIVERY_API + "updateSample/"+labId+"/"+sampleId;
    return this.http.put<any>(url,sample);
  }

  getSamplesOfDelivery(labId: string, deliveryID: string){
    let url = environment.BB_MA_DELIVERY_API + "getAllSample/"+labId+"/"+deliveryID;
    return this.http.get<any>(url);
  }

  removeSamples(body){
    let url = environment.BB_MA_DELIVERY_API + "removeSamples";
    return this.http.put<any>(url, body);
  }

  addUnsuitableSamples(labid:string, body:any){
    let url = `${environment.BB_MA_DELIVERY_API}markUnsuitableSamples/${labid}`
    return this.http.put<any>(url,body)
  }

  updateRedoSample(labId: string,  sampleRedoDetails: SampleRedoDTO){
    let url = environment.BB_MA_DELIVERY_API + "update/redoSample/"+labId;
    return this.http.put<any>(url, sampleRedoDetails);
  }

  getSampleInfoBySampleId(labId: string, sampleIds:Array<String>) {
    let url = environment.BB_MA_DELIVERY_API+"getSampleLists/"+labId;
    return this.http.post<any>(url, sampleIds);
  }

  getSampleInfoBySampleIdCount(labId: string, sampleIds:Array<string>):Observable<number> {
    const url = `${environment.BB_MA_DELIVERY_API}getSampleLists/count/${labId}`;
    return this.http.put<any>(url, sampleIds).pipe(map(result => result.data as number), timeout(environment.defaultTimeout));
  }

  weatherbyProcessUpdate(processUpdateDto: ProcessUpdateDTO,proxy:boolean){
    let url = `${environment.BB_MA_DELIVERY_API}weatherbys/processUpdate?proxy=${proxy}`
    return this.http.post<string>(url,processUpdateDto)
  }

  downloadDataExportEvaluationFile(filetype:string,data:any){
    let url = `${environment.BB_MA_DELIVERY_API}dataexport/${filetype}`
    const headers = new HttpHeaders({
      'Content-Type':'application/json'
    })
    return this.http.put(
      url,data,{
        responseType:'blob',
        headers : headers,
        observe:'response'
      }
    ).pipe(
      map((res)=>{
        return {
          fileContent : new Blob([res.body], { type:res.headers.get('Content-Disposition')}),
          filename: res.headers.get('Content-Disposition').split("=")[1],
          status:res.status
        }
       })
    )
  }

  getSelectedSampleFromDelivery(labId : string, sampleId: string, searchField: string): Observable<BBResponseContainer> {
    let url = environment.BB_MA_DELIVERY_API + "sample/"+labId+"/"+sampleId+"/"+searchField;
    return this.http.get<BBResponseContainer>(url);
  }

  putBarcodeInSample(sampleId: string, sample: any): Observable<BBResponseContainer> {
    let url = environment.BB_MA_DELIVERY_API + "sample/barcode/"+sampleId;
    return this.http.put<BBResponseContainer>(url, sample);
  }

    fetchNextAvailableChildSample(parentSample:Sample,workflowID:string): Observable<Sample>{
      const url = `${environment.BB_MA_DELIVERY_API}child/${workflowID}`;
      return this.http.post<BBResponseContainer>(url,parentSample).pipe(map(result => result.data as Sample),timeout(environment.defaultTimeout));
    }

  updateAssignedSampleTypeOfSamples(labId: string, sampleIds: any, assignedSampleType: any) {
    let url = environment.BB_MA_DELIVERY_API+'admin/update/sampleType/'+labId+"/"+assignedSampleType;
    return this.http.put<any>(url,sampleIds)
  }

  doRemovedSRCSamplesExist(labId: string): Observable<BBResponseContainer> {
    let url = environment.BB_MA_DELIVERY_API + "sample/src/removed/status/" + labId;
    return this.http.get<BBResponseContainer>(url);
  }

  getRemovedSRCSamplesData(labId: string): Observable<BBResponseContainer> {
    let url = environment.BB_MA_DELIVERY_API + "sample/src/removed/" + labId;
    return this.http.get<BBResponseContainer>(url);
  }

  getRemovedSRCSamplesCount(labId: string): Observable<number> {
    const url = `${environment.BB_MA_DELIVERY_API}sample/src/removed/count/${labId}`;
    return this.http.get<BBResponseContainer>(url).pipe(map(result => result.data as number),timeout(environment.defaultTimeout));
  }

  placeRemovedSRCSample(body: any): Observable<BBResponseContainer>{
    let url = environment.BB_MA_DELIVERY_API + "sample/placeRemoved";
    return this.http.put<BBResponseContainer>(url, body).pipe(timeout(environment.defaultTimeout));
  }

  announcePlates(plateAnnouncement: PlateAnnouncementDTO): Observable<BBResponseContainer> {
    const url = `${environment.BB_SAMPLE_PROCESSING_API}/announcePlates`;
    return this.http.post<BBResponseContainer>(url, plateAnnouncement).pipe(timeout(environment.defaultTimeout));
  }
}
